import * as yup from 'yup';

export const loginSchema = yup
	.object({
		phonenumber: yup.string().required('Телефон не указан').min(6, 'Телефон слишком короткий'),
		password: yup.string().required('Пароль не указан').min(6, 'Пароль слишком короткий'),
	})
	.required();
